import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "../../comps/ui/cards";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../comps/ui/table";
import { Link } from "react-router-dom";

export const ProductsTable = () => {

    const products = [];

    return (
        <main className="flex-1 p-4 sm:px-6 sm:py-0 md:gap-8">
            <Card>
                <CardHeader className="px-7">
                    <CardTitle>Products</CardTitle>
                    <CardDescription>
                        Manage your inventory at one place.
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>ID</TableHead>
                                <TableHead>Product</TableHead>
                                <TableHead className="hidden sm:table-cell">
                                    Quantity
                                </TableHead>
                                <TableHead className="hidden sm:table-cell">
                                    Min Quantity
                                </TableHead>
                                <TableHead className="hidden md:table-cell">
                                    Country
                                </TableHead>
                                <TableHead className="hidden md:table-cell">
                                    Alert Mark
                                </TableHead>
                                <TableHead className="text-right">Price</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {products.map(
                                (
                                    {
                                        product_id,
                                        product_name,
                                        manufacturer,
                                        actual_price,
                                    },
                                    id
                                ) => (
                                    <TableRow
                                        key={id}
                                        className={id % 2 == 0 ? "bg-accent" : ""}
                                    >
                                        <TableCell className="hidden md:table-cell">
                                            {product_id}
                                        </TableCell>
                                        <TableCell>
                                            <Link to={"/dashboard/orders/abc"}>
                                                <div className="font-medium">
                                                    {product_name}
                                                </div>
                                                <div className="hidden text-sm text-muted-foreground md:inline">
                                                    {manufacturer}
                                                </div>
                                            </Link>
                                        </TableCell>
                                        <TableCell className="hidden sm:table-cell">
                                            {20}
                                        </TableCell>
                                        <TableCell className="hidden md:table-cell">
                                            {6}
                                        </TableCell>
                                        <TableCell className="hidden md:table-cell">
                                            {"India"}
                                        </TableCell>
                                        <TableCell className="hidden md:table-cell">
                                            {3}
                                        </TableCell>
                                        <TableCell className="text-right">
                                            ₹ {actual_price}
                                        </TableCell>
                                    </TableRow>
                                )
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </main>    
    );
};
